import PropTypes from "prop-types";
import styles from './CustomDatePicker.module.scss';
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

const CustomDatePicker = ({
  label,
  date,
  onChange,
  error,
  showIcon = false,
  minDate,
  maxDate,
  disabled = false
}) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    setValue(date || null);
  }, [date]);

  return (
    <div className={`${styles.datePicker} ${error ? styles.errorInput : ''} ${showIcon ? styles.iconBox : ''}`}>
      {label && (
        <label className={styles.label}>{label}</label>
      )}
      <DatePicker
        selected={value}
        onChange={(newValue) => {
          setValue(newValue);
          onChange(newValue);
        }}
        popperPlacement="bottom"
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        showIcon={showIcon}
        toggleCalendarOnIconClick
        icon={<svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Icon" d="M11.8333 1V4.33333M5.16667 1V4.33333M1 7.66667H16M2.66667 2.66667H14.3333C15.2538 2.66667 16 3.41286 16 4.33333V16C16 16.9205 15.2538 17.6667 14.3333 17.6667H2.66667C1.74619 17.6667 1 16.9205 1 16V4.33333C1 3.41286 1.74619 2.66667 2.66667 2.66667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        }
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

CustomDatePicker.propTypes = {
  label: PropTypes.string,
  date: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showIcon: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  disabled: PropTypes.bool
}

export default CustomDatePicker;